import { ReactNode } from 'react';

import cx from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';

import styles from './action-sheet.module.scss';

interface ActionSheetProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  className?: string;
}

export default function ActionSheet({ isOpen, onClose, children, className }: ActionSheetProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0.2 } }}
            data-testid="action-sheet-backdrop"
            className={styles['action-sheet-backdrop']}
            onClick={onClose}
          />
          <motion.div
            initial={{ y: 100 }}
            animate={{ y: 0 }}
            exit={{ y: 100, transition: { duration: 0.2 } }}
            data-testid="action-sheet"
            transition={{ type: 'spring', stiffness: 120, damping: 16 }}
            className={cx(styles['action-sheet'], className)}
          >
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
